import { Controller } from "@hotwired/stimulus"
import NotificationController from "./notification_controller"

export default class extends Controller {
  static targets = ["selectAll", "checkbox", "counter", "batchButton"]
  static values = { 
    batchPath: String,
    resourceName: String,
    idFieldName: String,
    counterSingle: String,
    counterPlural: String,
    buttonSingle: String,
    buttonPlural: String,
    buttonDefault: String,
    alertMessage: String,
    errorMessage: String
  }

  connect() {
    this.updateUI()
  }

  toggleAll() {
    const isChecked = this.selectAllTarget.checked
    this.checkboxTargets.forEach(checkbox => {
      checkbox.checked = isChecked
    })
    this.updateUI()
  }

  toggleSingle() {
    this.updateUI()
  }

  updateUI() {
    const checkedCount = this.checkedBoxes.length
    const totalCount = this.checkboxTargets.length
    
    // Update select all checkbox
    if (this.hasSelectAllTarget) {
      this.selectAllTarget.checked = totalCount > 0 && checkedCount === totalCount
      this.selectAllTarget.indeterminate = checkedCount > 0 && checkedCount < totalCount
    }
    
    // Update counter
    if (this.hasCounterTarget) {
      const message = checkedCount === 1 ? this.counterSingleValue : this.counterPluralValue
      this.counterTarget.textContent = message.replace('%{count}', checkedCount)
    }
    
    // Update batch button
    if (this.hasBatchButtonTarget) {
      this.batchButtonTarget.disabled = checkedCount === 0
      if (checkedCount > 0) {
        const message = checkedCount === 1 ? this.buttonSingleValue : this.buttonPluralValue
        this.batchButtonTarget.textContent = message.replace('%{count}', checkedCount)
        this.batchButtonTarget.classList.remove("opacity-50", "cursor-not-allowed")
      } else {
        this.batchButtonTarget.textContent = this.buttonDefaultValue
        this.batchButtonTarget.classList.add("opacity-50", "cursor-not-allowed")
      }
    }
  }

  async performBatch(event) {
    event.preventDefault()
    
    const checkedIds = this.checkedBoxes.map(cb => cb.value)
    if (checkedIds.length === 0) {
      await NotificationController.alert(this.alertMessageValue)
      return
    }
    
    const data = {}
    // Transform venue_ids[] to venue_ids for backend compatibility
    const fieldName = this.idFieldNameValue.replace('[]', '')
    data[fieldName] = checkedIds
    
    fetch(this.batchPathValue, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
      },
      body: JSON.stringify(data)
    })
    .then(response => {
      if (response.ok) {
        window.location.reload()
      } else {
        throw new Error('Network response was not ok')
      }
    })
    .catch(async (error) => {
      console.error('Error:', error)
      await NotificationController.error("Erreur", this.errorMessageValue)
    })
  }

  get checkedBoxes() {
    return this.checkboxTargets.filter(cb => cb.checked)
  }
}